// Argus — microphones helper. Bloc ws-direct-batch-2 2026-05-05: WS direct flow.
// Mapping de la WS MicrophoneInfo la existing MicrophoneDevice pentru compat caller.

import { wsClient, WsAgentOfflineError } from './wsClient';
import type { MicrophoneDevice } from './enumDevices';

export interface FetchMicrophonesResult {
  microphones: MicrophoneDevice[];
  artifactId: string | null;
}

export async function fetchAgentMicrophones(agentId: string): Promise<FetchMicrophonesResult> {
  try {
    const result = await wsClient.requestEnumerateDevices(agentId);
    const microphones: MicrophoneDevice[] = result.microphones.map((m) => ({
      id: m.deviceId,
      friendlyName: m.name,
      isDefault: false,
      supportedFormats: [
        { sampleRate: m.defaultSampleRate, channels: m.defaultChannels, bits: 16 },
      ],
      error: null,
    }));
    return { microphones, artifactId: null };
  } catch (err) {
    if (err instanceof WsAgentOfflineError) {
      throw err;
    }
    throw err;
  }
}
